var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "table-container",
    attrs: {
      items: _vm.products,
      headers: _vm.headers,
      "item-key": "_id",
      "hide-actions": "",
      "disable-initial-sort": "",
    },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function (props) {
          return [
            _c("tr", [
              _c(
                "td",
                { class: { "input-highlight": !_vm.isProductsInvalid } },
                [
                  _vm.showSelect
                    ? _c("v-checkbox", {
                        attrs: {
                          "input-value": props.item.selected,
                          value: true,
                          "value-comparator": () => !!props.item.selected,
                          error: _vm.isProductsInvalid,
                          color: "secondary",
                          primary: "",
                          "hide-details": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectProduct($event, props.item)
                          },
                        },
                        model: {
                          value: props.item.selected,
                          callback: function ($$v) {
                            _vm.$set(props.item, "selected", $$v)
                          },
                          expression: "props.item.selected",
                        },
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n        " +
                      _vm._s(props && props.item.description) +
                      "\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("AppInput", {
                    class: {
                      "input-highlight": !_vm.showProductErrorStyle(props.item),
                    },
                    attrs: { value: _vm.productName(props.item), disabled: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("AppInput", {
                    class: {
                      "input-highlight": !_vm.showProductErrorStyle(props.item),
                    },
                    attrs: {
                      value: _vm.quantity(props.item),
                      disabled: "",
                      "append-outer": "KG",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { class: { "input-highlight": !_vm.isProductsInvalid } },
                [
                  _c("span", { staticClass: "gray--text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.totalSeedz(props.item)) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              props.item?.refusalReason?.description
                ? _c(
                    "td",
                    {
                      class: { "input-highlight": !_vm.isProductsInvalid },
                      staticStyle: { width: "350px" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.item?.refusalReason?.description) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }